import React, { Component } from 'react';
import { Button, Modal, Tag } from 'antd';
import { connect } from 'dva';
import { modelData, modelTypeData, getDefaultModuleData } from '../../../../utils/modelData';
import styles from './index.less';

@connect(({ homePage }) => ({
  ...homePage,
}))
class SelectModel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      activeModel: 1,
    };
  }

  componentDidMount() {
    const { formData } = this.props;
    const { stencilId } = formData;
    this.setState({ activeModel: stencilId });
  }

  componentWillReceiveProps() {
    const { formData } = this.props;
    const { stencilId } = formData;
    this.setState({ activeModel: stencilId });
  }

  selectModel = item => {
    this.setState({ activeModel: item.key });
  };

  onOk = () => {
    const { activeModel } = this.state;
    const { dispatch, formData } = this.props;
    const { modules } = formData;
    const modulesData = getDefaultModuleData(activeModel, modules);
    dispatch({
      type: 'homePage/saveState',
      payload: {
        formData: {
          ...formData,
          stencilId: activeModel,
          modulesData,
          modules: modulesData,
        },
      },
    });

    setTimeout(() => {
      this.changeModal(false);
    }, 0);
  };

  changeModal = status => {
    this.setState({ visible: status });
    if (!status) {
      const { formData } = this.props;
      const { stencilId } = formData;
      this.setState({ activeModel: stencilId });
    }
  };

  render() {
    const { visible, activeModel } = this.state;
    const { formData } = this.props;
    const { stencilId } = formData;
    return (
      <div className={styles['select-model']}>
        <div className="button-area">
          <Button onClick={() => this.changeModal(true)}>修改</Button>
          <Tag>{modelTypeData[stencilId]}</Tag>
        </div>
        <div className="tips">说明：请选择手机端展示模板样式</div>
        <Modal
          title="选择模板"
          centered
          key="modal-template-key"
          visible={visible}
          width={675}
          className={styles['select-modal']}
          onCancel={() => this.changeModal(false)}
          onOk={this.onOk}
        >
          <div className="model-wrap">
            {modelData.map(item => {
              return (
                <div
                  className={activeModel === item.key ? 'active' : ''}
                  onClick={() => this.selectModel(item)}
                >
                  <img src={item.img} alt="" />
                  <div>{item.name}</div>
                </div>
              );
            })}
          </div>
        </Modal>
      </div>
    );
  }
}

export default SelectModel;
